import EventDispatcher from './EventDispatcher';
import Global from './Global';
import { changeLanguage } from './lang';

export default class LangSelection {
  constructor() {
    document
      .querySelector('#english')
      .addEventListener('mousedown', this.onSelectLang.bind(this, 'ENG'));

    document
      .querySelector('#arabic')
      .addEventListener('mousedown', this.onSelectLang.bind(this, 'ARB'));

    this.ageChecked = false;
    this.agreeChecked = false;
    Global.soundEnabled = true;
  }

  init() {
    this.isChecked = true;

    this.events = EventDispatcher.getObj();
    this.events.addEventListener('LOADER_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('GAME_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));
  }

  onEvents(data) {
    switch (data.message.event_type) {
      case 'show_screen':
        this.showScreen(data.message.data.screenKey);
        break;
    }
  }

  onSelectLang(lang) {
    Global.lang = lang;
    Global.clickUpdater(Global.lang == 'ENG' ? 'english' : 'arabic');
    if (Global.lang == 'ENG') {
      document.querySelector('.btn_toggle.en').click();
    } else {
      document.querySelector('.btn_toggle.ar').click();
    }
    changeLanguage();
    this.onProceed();
  }

  showScreen(screenKey) {
    if (screenKey != 'LangSelection') return false;

    this.activateLangSelection();
  }

  activateLangSelection() {
    document.querySelector('#languageSelection_scr').classList.add('active');
    let k = 0;
    const percentage = 100 / 23;
    const int = setInterval(() => {
      document.querySelector(
        '.languageOptions'
      ).style.backgroundPosition = `0px ${k * percentage}%`;
      k++;
      if (k === 24) {
        clearInterval(int);
        document.querySelector('#english1').style.opacity = 1;
        document.querySelector('#arabic1').style.opacity = 1;
      }
    }, 100);
  }

  onProceed() {
    // this.events.dispatchEvent({
    //   type: 'LOADER_EVENTS',
    //   message: {
    //     event_type: 'switch_page',
    //     data: {
    //       screenKey: 'Instruction',
    //       lang: Global.lang,
    //     },
    //   },
    // });

    if (typeof DeviceOrientationEvent.requestPermission === 'function') {
      DeviceOrientationEvent.requestPermission()
        .then((permissionState) => {
          if (permissionState === 'granted') {
            Global.deviceOrientationAvailable = true;
            this.enableCamera();
          } else {
          }
        })
        .catch(console.error);
    } else {
      Global.deviceOrientationAvailable = true;
      this.enableCamera();
    }
  }

  enableCamera() {
    this.events.dispatchEvent({
      type: 'GAMESCENE_EVENTS',
      message: {
        event_type: 'gyro_permission_update',
        data: {},
      },
    });
    navigator.mediaDevices
      .getUserMedia({
        video: {
          facingMode: 'environment',
        },
      })
      .then((stream) => {
        // Get the video element
        const videoElement = document.getElementById('cameraView');

        // Set the video source to the stream from the camera
        videoElement.srcObject = stream;

        this.events.dispatchEvent({
          type: 'LOADER_EVENTS',
          message: {
            event_type: 'switch_page',
            data: {
              screenKey: 'Instruction',
              lang: Global.lang,
            },
          },
        });
      })
      .catch((error) => {
        console.log('Error accessing the camera: ', error);
      });
  }
}
